import DeleteIcon from '@mui/icons-material/Delete'
import SearchIcon from '@mui/icons-material/Search'
import { Grid, Stack } from '@mui/material'

import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { acCleanCompany, acGetCompany } from '../../store/actions'
import { removeSpecialCharacters } from '../../utils'
import { PrimaryButton, Alert, CleanButton } from '../default'

import { FormInputCnpj, FormInputText } from './formInputs'

/**
 * @description Renders a form component for searching a company.
 *
 * @author Maria Eduarda Franke, Isadora Botassari
 * @returns {JSX.Element} The rendered form component.
 */
export const SearchCompanyForm = () => {

    const dispatch = useDispatch()

    const [isSearch, setIsSearch] = useState(true)

    const isSearchingForCompany = useSelector(state => state.company.isSearchingForCompany)
    const hasErrorSearchedCompany = useSelector(state => state.company.hasErrorSearchedCompany)

    const { control, watch, trigger, reset, setValue, formState: { errors } } = useFormContext()

    const cnpj = watch('cnpj')

    useEffect(() => {
        if (errors.cnpj) {
            trigger('cnpj')
        }
    }, [cnpj])

    const onSearch = async () => {

        const isValid = await trigger('cnpj')

        if (!isValid)
            return

        dispatch(acGetCompany(removeSpecialCharacters(cnpj)))
            .then(company => {
                setValue('companyName', company.name, { shouldValidate: true })
                setIsSearch(false)
            })
            .catch(error => console.error(error))
    }

    const onReset = () => {
        reset()
        dispatch(acCleanCompany())
        setIsSearch(true)
    }

    return (
        <Stack gap={2}>

            <Grid container alignItems='center' spacing={2}>
                <Grid item flexGrow={1}>
                    <FormInputCnpj
                        name='cnpj'
                        label='CNPJ'
                        control={control}
                        errors={errors.cnpj}
                        disabled={!isSearch}
                        fullWidth
                        required
                    />
                </Grid>
                {isSearch ? (
                    <Grid item xs='auto'>
                        <PrimaryButton
                            label='Buscar'
                            Icon={SearchIcon}
                            loading={isSearchingForCompany}
                            type='button'
                            onClick={onSearch}
                        />
                    </Grid>
                ) : (
                    <Grid item xs='auto'>
                        <CleanButton
                            label='Limpar'
                            Icon={DeleteIcon}
                            type='button'
                            onClick={onReset}
                        />
                    </Grid>
                )}

            </Grid>

            <FormInputText
                name='companyName'
                label='Razão Social'
                control={control}
                errors={errors.companyName}
                fullWidth
                required
                disabled
            />

            {hasErrorSearchedCompany && (
                <Alert severity='error' message='Empresa não cadastrada!' />
            )}

        </Stack>
    )

}
